export const init = () => {

  // TRACKER 'BASKET'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.funnel.basket);
  const sep = AnalyticsConstants.separatorST;
  const fwk = CUBE.Analytics;

  const getProductDetails = $element => {
    const $product = $element.closest('.faux-table-wrapper');
    const refId = $product.find('[data-model-id]').attr('data-model-id');
    let productNature = '';
    let productName = '';
    let productId = '';
    let model = fwk.utils.basketpage.getModel($product);
    if (!model) {
      model = fwk.utils.datalayer.getModel(refId);
    }

    if (model) {
      productNature = 'PRODUCT_NATURE'; // TODO
      if (model.id) {
        productName = model.name;
        productId = model.id;
      } else {
        productId = refId;

      }
    } else {
      productNature = 'PRODUCT_NATURE'; // TODO
      productName = $element.closest('.product-item').find('.product-title [data-tprop="product-name"]').text().trim();
      productId = $element.closest('.product-item').find('.modify-product[model-id]').attr('model-id');
    }

    return productName + sep + productId;
  };

  const getProductValue = $element => {
    const quantity = 1;
    const $product = $element.closest('.faux-table-wrapper');
    const refId = $product.find('[model-id]').attr('model-id');

    if ($product.find('.price-info [data-price]').data('price')) {
      return parseFloat($product.find('.price-info [data-price]').data('price')) * quantity;
    }
    let model = fwk.utils.basketpage.getModel($product);
    if (!model) {
      model = fwk.utils.datalayer.getModel(refId);
    }

    if (model.price) {
      return parseFloat(model.price) * quantity;
    }
    return parseFloat($product.data('price')) * quantity;

  };

  // - ChangeQuantityCart on click on '+' / '-'
  const changeQuantityCart = new AnalyticsClickEvent('changeQuantityBtn', tracker.defaultEvent());
  changeQuantityCart.domContainer = 'div.quantity-selector';
  changeQuantityCart.domElement = 'button.icon';
  changeQuantityCart.getAction = $element => $element.hasClass('icon-minus') ? 'RemoveQuantityCart' : 'AddQuantityCart';
  changeQuantityCart.getLabel = $element => getProductDetails($element);
  tracker.addEvent(changeQuantityCart);

  // - ChangeQuantityCart on change from the input
  const changeQuantityCartFromInput = new AnalyticsTriggerEvent('changeQuantityInput', tracker.defaultEvent());
  changeQuantityCartFromInput.trigger = 'change';
  changeQuantityCartFromInput.domContainer = 'div.quantity-selector';
  changeQuantityCartFromInput.domElement = 'input.quantity-input';
  changeQuantityCartFromInput.options.action = 'ChangeQuantityCart';
  changeQuantityCartFromInput.getLabel = $element => getProductDetails($element);
  tracker.addEvent(changeQuantityCartFromInput);

  // - RemoveProduct
  const removeProduct = new AnalyticsClickEvent('removeProduct', tracker.defaultEvent());
  removeProduct.options.action = 'RemoveProduct';
  removeProduct.domElement = '.cart-element span.delete-item';
  removeProduct.getLabel = $element => getProductDetails($element);
  tracker.addEvent(removeProduct);

  // MODIFY PRODUCT
  const modifyProduct = new AnalyticsClickEvent('modifyProduct', tracker.defaultEvent());
  modifyProduct.domElement = '.modify-product';
  modifyProduct.options.action = 'ModifyProduct';
  modifyProduct.getLabel = $element => getProductDetails($element);
  modifyProduct.getValue = $element => getProductValue($element);
  modifyProduct.stopEvent = () => {
    if ($('#cartridgeDivProductModification').hasClass('active')) return true;
    return false;
  };
  tracker.addEvent(modifyProduct);

  // CONFIRM MODIFY PRODUCT
  const confirmModifyProduct = new AnalyticsClickEvent('confirmModifyProduct', tracker.defaultEvent());
  confirmModifyProduct.domElement = '#confirm_modification';
  confirmModifyProduct.options.action = 'ConfirmModifyProduct';
  confirmModifyProduct.getLabel = $element => getProductDetails($element);
  confirmModifyProduct.getValue = $element => getProductValue($element);
  tracker.addEvent(confirmModifyProduct);

  // - ProceedToOrder
  const proceedToOrder = new AnalyticsQueueEvent('proceedToOrder', tracker.defaultEvent());
  proceedToOrder.trigger = 'click';
  proceedToOrder.domElement = '.cart-summary #pay-order-btn,.dkt-checkout-payment #pay-order-btn';
  proceedToOrder.options.action = 'ProceedToOrder';
  proceedToOrder.options.label = 'OrderBasketPage';
  proceedToOrder.getValue = () => parseInt($('[data-tracking-basket-amount]').data('tracking-basket-amount'),10);
  tracker.addEvent(proceedToOrder);

  // - ContinueShopping
  const continueShopping = new AnalyticsClickEvent('continueShopping', tracker.defaultEvent());
  continueShopping.options.action = 'ContinueShopping';
  continueShopping.options.label = '';
  continueShopping.domElement = '.payment-bar-content a.l-back.white, .cart-empty a.cta';
  tracker.addEvent(continueShopping);

  // - GoBackToProduct
  const goBackToProduct = new AnalyticsClickEvent('goBackToProduct', tracker.defaultEvent());
  goBackToProduct.options.action = 'GoBackToProduct';
  goBackToProduct.domContainer = '#cartridgeDivId';
  goBackToProduct.domElement = 'div.product-img, div.product-title a:not([href="#"])';
  goBackToProduct.getLabel = $element => getProductDetails($element);
  tracker.addEvent(goBackToProduct);

  // CrossSell - Move to cart
  const eventAddToCartCrossSell = new AnalyticsEvent('virtualEventAddToCartCrossSell', tracker.defaultEvent());
  tracker.addEvent(eventAddToCartCrossSell);

  //Begin coupon events
  const couponApply = new AnalyticsClickEvent('couponApply', tracker.defaultEvent());
  couponApply.options.action = 'Coupon';
  couponApply.domContainer = '#coupon-bloc-container';
  couponApply.domElement = '.btn-apply-coupon-code';
  couponApply.options.label = 'Apply';
  tracker.addEvent(couponApply);

  const couponRemove = new AnalyticsClickEvent('couponRemove', tracker.defaultEvent());
  couponRemove.options.action = 'Coupon';
  couponRemove.domContainer = '#coupon-bloc-container';
  couponRemove.domElement = '.js-btn-delete-code';
  couponRemove.options.label = 'Remove';
  tracker.addEvent(couponRemove);

  const couponHelp = new AnalyticsClickEvent('couponHelp', tracker.defaultEvent());
  couponHelp.options.action = 'Coupon';
  couponHelp.domContainer = '#coupon-bloc-container';
  couponHelp.domElement = '.icon-help-line';
  couponHelp.getLabel = $element => {
    if (!$element.data('status')) {
      $element.data('status', 'open');
      return 'Help - Open';
    }
    $element.removeData('status');
    return 'Help - Close';

  };
  tracker.addEvent(couponHelp);

  const couponAdd = new AnalyticsClickEvent('couponAdd', tracker.defaultEvent());
  couponAdd.options.action = 'Coupon';
  couponAdd.domContainer = '#coupon-bloc-container';
  couponAdd.domElement = '.js-btn-add-coupon-code';
  couponAdd.getLabel = $element => {
    if (!$element.data('status')) {
      $element.data('status', 'add');
      return 'Add';
    }
    $element.removeData('status');
    return 'Cancel';

  };
  tracker.addEvent(couponAdd);
  //End coupon events


  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};




// WEBPACK FOOTER //
// ./src/analytics/trackers/funnel/basket-tracker.js